import axios from "axios";

const API_BASE_URL = "https://appstore.indzs.com/panel/api";
const PUBLIC_TOKEN = "4|J5SXhZOPjtYgGu7smZ70e9xfspMOWlAlFIjg9FlYa0faf412";

const Constrants = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    }
});

Constrants.interceptors.request.use((config) => {
    if (!config.url.includes('/login') && !config.url.includes('/register')) {
        const token = localStorage.getItem("token") || PUBLIC_TOKEN;
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
    } else {
        console.log('Interceptor - Skipping Bearer token for auth endpoints');
    }

    return config;
});

export default Constrants;

export { API_BASE_URL, PUBLIC_TOKEN };
